import { useI18n } from 'vue-i18n'
import { ColumnItem } from '~/lib/select-column'
import { computed } from 'vue'
import { useTableColumns } from '~/composables/common/useTableColumns'
import type { SwitchingExtended } from '~/lib/switchings'

export function useSwitchingColumns(activityId: number) {
  const { t } = useI18n()

  const base = computed((): ColumnItem<SwitchingExtended>[] => [
    {
      id: 'id',
      title: 'CommonId',
      value: 'id',
    },
    {
      id: 'equipment.name',
      title: 'SwitchingsTableColumnEquipment',
      value: 'equipment.name',
    },
    {
      id: 'switching_block.start_earliest',
      title: 'SwitchingsTableColumnStartEarliest',
      value: 'switching_block.start_earliest',
      align: 'center',
    },
    {
      id: 'start',
      title: 'SwitchingsTableColumnStart',
      value: 'start',
      align: 'center',
    },
    {
      id: 'end',
      title: 'SwitchingsTableColumnEnd',
      value: 'end',
      align: 'center',
    },
    {
      id: 'switching_block.end_latest',
      title: 'SwitchingsTableColumnEndLatest',
      value: 'switching_block.end_latest',
      align: 'center',
    },
    {
      id: 'duration_days',
      title: 'SwitchingsTableColumnDuration',
      value: 'duration_days',
      align: 'center',
    },
    {
      id: 'duration_release_hours',
      title: 'SwitchingsTableColumnDurationReleaseHours',
      value: 'duration_release_hours',
      align: 'center',
    },
    {
      id: 'sub_project.project.name',
      title: 'SwitchingsTableColumnProject',
      value: 'sub_project.project.name',
    },
    {
      id: 'sub_project.name',
      title: 'SwitchingsTableColumnSubProject',
      value: 'sub_project.name',
    },
    {
      id: 'switching_category_type',
      title: 'SwitchingsTableColumnSwitchingsCategory',
      value: 'switching_category_type',
      // sortable: false,
    },
    {
      id: 'info_tbt',
      title: 'SwitchingsTableColumnInfoTBT',
      value: 'info_tbt',
      // sortable: false,
    },
    {
      id: 'info_tbt.continuous',
      title: 'SwitchingsTableColumnInfoTBTContinuous',
      value: 'info_tbt.continuous',
      // sortable: false,
    },
    {
      id: 'info_tbt.alternating',
      title: 'SwitchingsTableColumnInfoTBTAlternating',
      value: 'info_tbt.alternating',
      // sortable: false,
    },
    {
      id: 'import_file.file_name',
      title: 'SwitchingsTableColumnImportFile',
      value: 'import_file.file_name',
      // sortable: false,
    },
  ])

  const table = useTableColumns({
    storageKey: `${activityId}.switchings`,
    columnsBase: base,
    columnsTitle: (item) => t(item.title, 0),
  })

  return {
    base,
    table,
  }
}
